import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";

import { collectAnalyses, getMissingRequired } from "./document-intake-state";
import { DOCUMENT_INTAKE_CSS } from "./document-intake-styles";
import DocumentSlot from "./document-slot";
import IntakeAiBanner from "./intake-ai-banner";
import { useDocumentUploads } from "./use-document-uploads";

/**
 * Pide una lista de documentos, los manda a analizar y devuelve los resultados a quien lo monto.
 * No sabe a que modulo pertenece: recibe `requirements` ([{ type, label, required }]) y entrega
 * `onFinish(analyses)` con los analisis hechos (vacio si el usuario omitio todo). Es el modal de
 * "documentos faltantes"; el alta de un caso usa el asistente por pasos.
 */
const DocumentIntakeModal = ({ show, title, requirements, onFinish, onCancel }) => {
  const { entries, typesByKey, upload, isAnyBusy } = useDocumentUploads(show);

  const busy = isAnyBusy(requirements);
  const missing = getMissingRequired(requirements, entries);
  const analyses = collectAnalyses(requirements, entries);

  return (
    <Modal show={show} onHide={onCancel} backdrop="static" centered size="lg">
      <style>{DOCUMENT_INTAKE_CSS}</style>
      <Modal.Header closeButton={!busy}>
        <Modal.Title>{title || "Documentos del asegurado"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <IntakeAiBanner>
          Sube los documentos y la IA los leerá para prellenar la solicitud. Revisarás los
          datos antes de crear el caso, y puedes continuar sin documentos.
        </IntakeAiBanner>
        <Row>
          {requirements.map((r) => (
            <Col md={requirements.length === 1 ? 12 : 6} key={r.type} className="mb-3">
              <DocumentSlot
                requirement={r}
                type={typesByKey[r.type]}
                entry={entries[r.type]}
                onFile={(file) => upload(r.type, file)}
              />
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} disabled={busy}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={() => onFinish(analyses)}
          disabled={busy || missing.length > 0}
        >
          {analyses.length > 0 ? "Continuar" : "Continuar sin documentos"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DocumentIntakeModal;
